import api from "../../service";
import middleware from "../../middleware";

class PlanService extends middleware {
	constructor() {
		super();
		this.url = `${api.defaults.baseURL}/journal/plan`;
	}

	async getAll() {
		const response = await api.get(`${this.url}s/active`);
		return response;
	}

	async getByStudentId(id) {
		const response = await api.get(`${this.url}ByStudent/${id}`);
		return response;
	}

	async get(id) {
		const response = await api.get(`${this.url}/${id}`);
		return response;
	}
	async getAllPlans(filter) {
		const response = await api.get(`${base_url}journal/getAllPlans`, {
			params: {
				...api.params,
				...filter
			},
		});
		return response;
	}
	async checkUsage(id) {
		const response = await api.get(`${basic_base_url}/plans/plans/check_plan_usage/${id}`);
		return response;
	}
	async deletePlan(plan_id, template_id) {
		const formData = new FormData;
		// Append the data to the FormData object
		formData.append('plan_id', plan_id);
		formData.append('template_id', template_id);
		const response = await api.post(`${basic_base_url}/plans/plans/delete_plans/`, formData);
		return response;
	}
	async changeStatus(id) {
		const data = [];
		// Append the data to the FormData object
		const response = await api.put(`${base_url}journal/planUpdate/${id}`, data);
		return response;
	}
	async getPlanStudents(planStatus) {
		const response = await api.get(`${base_url}journal/getPlanStudents/${planStatus?1:0}`);
		return response;
	}
	async getPlanForArchiveStudents() {
		const response = await api.get(`${this.url}s/archive`);
		return response;
	}

}

export default PlanService
